<template>
<v-dialog
    v-model="dialog"
    max-width="960"
>
    <v-card>
    <v-card-title class="headline">Create Contact Request</v-card-title>

    <v-card-text>
        <m-autocomplete-phone-number
            v-model="endpoint"
            autofocus
            v-on:input="onInputEndpoint"
            :organization_id="organization_id"
        />

        <v-text-field
            label="Customer Name"
            v-model="customer_name"
            autocomplete="off"
        />

        <v-textarea
            label="Message"
            v-model="message"
            rows="1"
            auto-grow
        />

        <m-edit-blobs
            v-model="blob_ids"
            :process_media="false"
            :externally_visible="false"
        />

        <div
            v-if="in_conversation"
            style="margin-top: 10px; margin-bottom: 0px"
        >
            <a 
                v-on:click="onClickPutConversationInMessage"
            >
                Make the message a copy of the conversation
            </a>
        </div>

        <div
            v-if="in_conversation"
            style="margin-top: 5px"
        >
            Most recent assignemnts (up to 5)
            <ul>
                <li
                    v-for="(item, index) in last_assignemnts"
                    :key="'last_assign_'+index"
                >
                    {{item.assigned_to_employee_label}} - {{$rc.pretty(item.time,'date_and_time')}}
                </li>
            </ul>
        </div>

        <v-select
            label="Assign To"
            :items="employee_choices"
            v-model="assign_to_employee_ids"
            multiple
            chips
        />

        <v-textarea
            v-if="in_conversation"
            label="Note (to add to conversation)"
            v-model="add_note_to_conversation"
            rows="1"
            auto-grow
        />

        <v-checkbox
            v-if="in_conversation"
            label="Archive Conversation"
            v-model="archive_conversation"
            v-on:change="saveArchiveConversation"
        />
			
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!isValid()"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');
const { v4: uuidv4 } = require('uuid');

export default {

    props: {
        in_conversation: {
            type: Boolean,
            default: function() { return false; },
        },
    },

    data() {
        return {
            dialog: false,
            
            customer_name: null,
            endpoint: null,
            message: null,
            assign_to_choices: [],
            assign_to_employee_ids: null,
            blob_ids: [],

            organization_id: null,


            employee_choices: [],
            archive_conversation: false,
            add_note_to_conversation: null,
            conversation_id: null,

            last_assignemnts: [],
        }
    },

    methods: {
        saveArchiveConversation()
        {
            window.localStorage.setItem('rc-create-contact-dialog-archive-conversation-cb',''+this.archive_conversation);
        },

        onClickPutConversationInMessage()
        {
             this.$rc.getFlatConversation(
                this.conversation_id,
            
                (data) => {
                    this.message = data.flat_text;
                },
            
                () => {
                },
            );
        },

        loadLastAssignments()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/contact-requests/create-employee-contact-request/get-profile',
            
                'params' : {
                        'organization_id': this.organization_id,
                    },
            
                'on_success': (data) => {
                        this.last_assignemnts = data.last_assignments;
                    },
            
                'on_error': 'Unable to load recent assignemnts',
            });
        },

      

        showDialog(organization_id, endpoint, conversation_id) 
        {
            this.updateEmployeeChoices(organization_id);
            this.customer_name = null;
            this.endpoint = null;
            this.message = null;
            this.assign_to = null;
            this.organization_id = organization_id;
            this.blob_ids = [];
            this.archive_conversation = window.localStorage.getItem('rc-create-contact-dialog-archive-conversation-cb') == 'true';
            this.add_note_to_conversation = null;
            this.conversation_id = conversation_id;
            this.last_assignemnts = [];

            if ( this.in_conversation )
            {
                this.loadLastAssignments();
            }

            this.dialog = true;

            if ( endpoint != null )
            {
                let search = {
                    'full_text' : endpoint,
                    'organization_id': this.organization_id,
                };

                this.$rc.searchPhoneNumbersFullText(
                search,
                (data) =>
                {
                    if ( data.results == null || data.results.length == 0 )
                    {
                        this.endpoint = {
                            'text' : E164.prettyPrintUsPhoneNumber(endpoint),
                            'value' : E164.prettyPrintUsPhoneNumber(endpoint),
                            'name' : E164.prettyPrintUsPhoneNumber(endpoint),
                        };

                        return;
                    }

                    let label = data.results[0].contact_label == '' ? E164.prettyPrintUsPhoneNumber(data.results[0].endpoint) : data.results[0].contact_label;

                    this.endpoint = {
                        'text'  : label,
                        'value' : data.results[0].endpoint,
                        'name'  : label,
                    };

                    if ( data.results[0].contact_label != '' )
                        this.customer_name = data.results[0].contact_label;
                }
            );
            }
        },

        updateEmployeeChoices(organization_id)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'LIST: /api/v1/organizations/employees/labels',
            
                'params' : {
                        'organization_id': organization_id,
                    },
            
                'on_success': (data) => {
                        this.employee_choices = [];

                        for ( let i = 0; i < data.teams.length; i++ )
                        {
                            this.employee_choices.push({
                                'text': 'Team: '+data.teams[i].text,
                                'value': data.teams[i].value
                            });
                        }

                        for ( let i = 0; i < data.choices.length; i++ )
                        {
                            if ( data.choices[i].is_archived )
                                continue;
                                
                            this.employee_choices.push({
                                'text': 'Team Member: '+data.choices[i].text,
                                'value': data.choices[i].value
                            });
                        }
                    },
            
                'on_error': 'Unable to list team members',
            });
        },

        isValid()
        {   
            if ( this.customer_name == null || this.customer_name.trim().length == 0 ) return false;
            if ( this.endpoint == null ) return false;
            if ( this.assign_to_employee_ids == null ) return false;

            return true;
        },
        
        onOk()
        {
           this.dialog = false;

           this.$emit('ok', {
               'customer_name' : this.customer_name,
               'customer_endpoint' : this.endpoint.value,
               'message' : this.message,
               'blob_ids' : this.blob_ids,
               'assign_to_employee_ids' : this.assign_to_employee_ids,
               'archive_conversation': this.archive_conversation,
               'add_note_to_conversation': this.add_note_to_conversation,
           });
        },

        onInputEndpoint(new_endpoint)
        {
            if ( new_endpoint.name == null ) return;

            this.customer_name = new_endpoint.name;
            
            new_endpoint.text = E164.prettyPrintUsPhoneNumber(new_endpoint.value);
            this.endpoint = new_endpoint;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>